import React, { useContext, useEffect, useState } from 'react'
import Navbar from './navbar'
import ShowAuctions from './pages/ShowAuctions'
import {barely, barely_black_bg_img} from '../../public/LoginImages/importimages'
import { BidderRegister } from './pages'
import { AdminLogin } from '../admin'
const Homepage = () => {

  return (
    
    <div style={{ backgroundImage: `url('${barely_black_bg_img}')`, height: "100vh", width: '100vw', backgroundSize: '100vw 100vh'}}>
      {/* <Navbar /> */}
      {/* <ShowAuctions/> */}
      {/* <BidderRegister/> */}
      <AdminLogin/>
    </div>
  )
}

export default Homepage